import { ChangeDetectionStrategy, Component, input, output, computed } from '@angular/core';
import { SharedMaterialUIModule } from '@shared/modules/shared-material-ui.module';
import { HistoryListComponent } from '@shared/components/history-list/history-list.component';
import {
  ClientCompanyResponse,
  ClientConfigurationResponse,
  ClientTransactionHistoryResponse,
} from '../../client.model';
import { CompanyResponse } from '@features/company/company.model';
import { SHARED_IMPORTS } from '@shared/modules/shared-imports.module';
import { DataTableColumn } from '@shared/components/data-table.component';
import { ClientActions } from '../client-table/client-actions-enum';
import { useClientActionMenu } from '../client-table/client-action-menu-composable';

@Component({
  selector: 'client-detail-panels',
  imports: [HistoryListComponent, ...SharedMaterialUIModule, ...SHARED_IMPORTS],
  templateUrl: './client-detail-panels.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class ClientDetailPanelsComponent {
  readonly ClientActions = ClientActions;
    readonly canManage = input(false);
    readonly data = input<any[]>([]);
    readonly detailsTitle = input<string>('Title');
  
    readonly manageDetails = output<{
      data?: ClientCompanyResponse;
      action: ClientActions.Create | ClientActions.Edit | ClientActions.Toggled;
    }>();
  
    protected readonly columns: DataTableColumn<ClientCompanyResponse>[] = [
        {
          id: 'uniqueCompanyCode',
          header: 'Unique code',
          value: (data) => data.uniqueCompanyCode,
          cellClass: 'px-3 py-3 font-medium',
        },
        {
          id: 'companyClientCode',
          header: 'Company client code',
          value: (data) => data.companyClientCode,
          cellClass: 'px-3 py-3 font-medium',
        },
        {
          id: 'status',
          header: 'Status',
          value: (data) => (data.isActive ? 'Active' : 'Inactive'),
          cellClass: 'px-3 py-3',
        },
    ];
    readonly actionMenuItems = useClientActionMenu().clientDetailsMenuItems;
    readonly actions: Record<string, any> = {
      [ClientActions.Toggled]: this.manageDetails,
      [ClientActions.Edit]: this.manageDetails,
      [ClientActions.Create]: this.manageDetails,
    };

  readonly companies = input<CompanyResponse[]>([]);

  readonly companyFilterChanged = output<string | null>();

  readonly manageClientCompany = output<{
    clientCompany?: ClientCompanyResponse;
    action: ClientActions.Create | ClientActions.Edit | ClientActions.Toggled;
  }>();

  protected onCompanyFilterChanged(event: Event): void {
    const target = event.target as HTMLSelectElement;
    const value = target.value.trim();

    this.companyFilterChanged.emit(value.length > 0 ? value : null);
  }
}